import React from "react";
import { Flex, Box, P, Button } from "ui-components";
import { buttonThemes } from "ui-components/theme";
import FormattedMessage from "components/FormattedMessage";
import { gotoUrl } from "utils/helpers";
import { useSelector } from "react-redux";
import { makeSelectRateLimitErrorSelector } from "ducks/selectors/appGlobalSettings";

const _imageStyle = {
  width: 250,
  mt: 40
};

const _messageStyle = {
  mt: 57,
  mx: 20,
  textAlign: "center !important",
  fontWeight: "bold"
};

const RateLimitError = ({ errorPagesConfig }) => {
  const rateLimitErrorSettings = useSelector(
    makeSelectRateLimitErrorSelector()
  );
  // Checking if overlay screen configuration exists in rate limit error settings
  let overlay_screen = {};
  if (rateLimitErrorSettings) {
    overlay_screen =
      rateLimitErrorSettings?.error?.message?.error?.action?.data
        ?.overlay_screen;
  }

  const config = errorPagesConfig?.["rateLimitError"] || {};

  // Getting specific configuration for the rateLimitError page from errorPagesConfig
  const errorImage =
    overlay_screen.image_web_url ||
    "https://ufone-onic-assets.s3.ap-southeast-1.amazonaws.com/01-Webfront-Assets/Maintenance.png";

  const imageStyle = { ..._imageStyle, ...(config.imageStyle || {}) };

  const imageAlt = config.imageAlt || "rateLimitError";

  const redirectUrl = overlay_screen?.webAction?.cta_link;

  const message =
    rateLimitErrorSettings?.error?.message?.error?.description ||
    "error_message_429";

  const messageStyle = { ...(config.messageStyle || {}), ..._messageStyle };

  const handleRedirectOnClick = () => {
    gotoUrl(redirectUrl, true, { relaunch: true }, false, false, true);
  };

  const buttonText = overlay_screen?.webAction?.title || "Contact Us";

  const backgroundColor = `${buttonThemes?.purple?.backgroundColor} !important`;
  const hoverColor = `${buttonThemes?.purple?.hoverColor} !important`;

  const buttonStyle = {
    background: backgroundColor,
    color: "#FFF",
    borderColor: backgroundColor,
    minWidth: "10rem !important",
    py: 12,
    borderRadius: 23,
    ":hover": {
      background: hoverColor,
      borderColor: hoverColor
    }
  };

  return (
    <Flex alignItems="center" flexDirection="column">
      <Box sx={imageStyle}>
        <img alt={imageAlt} src={errorImage} width="100%" height="auto" />
      </Box>
      <P sx={messageStyle}>
        <FormattedMessage html id={message} />
      </P>
      <Box sx={{ mt: 20 }}>
        <Button sx={buttonStyle} onClick={handleRedirectOnClick}>
          <FormattedMessage id={buttonText} />
        </Button>
      </Box>
    </Flex>
  );
};

export default RateLimitError;
